module.exports = __webpack_public_path__ + "img/invite-bg-en.2547919b.png";